<div [ngClass]="typeClass" >  
    <div [ngClass]="typePosition"  >
        <div class="span"  [innerHtml]="data" > </div> 
    </div> 
</div>